import React, {FC, useEffect, useRef, useState} from "react";
import cls from "../../../atoms/atoms.module.scss";
import {CustomSelectArrow} from "../../../svg";
import {PropsFields} from "../../../atoms/customFields/types";

export interface IDropDown extends PropsFields {
    item: any,
    handleChange: (value: string) => void
}


const CustomDropdown: FC<IDropDown> = (
    {
        item: {
            attribute_code,
            field_options
        },
        handleChange,
    }
) => {
    const [open, setOpen] = useState<boolean>(false)
    const [dropDownLabel, setDropDownLabel] = useState<string>(attribute_code)
    const rootRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        setDropDownLabel(attribute_code)
    }, [attribute_code]);

    useEffect(() => {
        const handleEvent = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleEvent)
        return () => document.removeEventListener('mousedown', handleEvent)
    }, [])

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, selectedLabel: string) => {
        const target = e.target as HTMLDivElement
        handleChange(selectedLabel as any)
        setDropDownLabel(field_options[Number(target.id)].label)
        setOpen(false)
    }

    const displayDropDown = {
        "true": "block",
        "false": "none"
    }
    const openDropDown = {
        "true": cls.drop_down_opened,
        "false": ""
    }

    return (
        <div className={cls.drop_down} ref={rootRef}>
            <div className={cls.drop_down_btn} onClick={() => setOpen(prevState => !prevState)}>
                {dropDownLabel}
                <CustomSelectArrow className={`${cls.drop_down_arrow} ${openDropDown[`${open}`]}`}/>
            </div>
            <div style={{display: displayDropDown[`${open}`]}} className={cls.drop_down_block}>
                {field_options.map((option: any, index: number) => {
                    return (
                        <div key={index}
                             id={String(option.id)}
                             className={cls.drop_down_option}
                             onClick={(e) => handleClick(e, option.key)}
                        >
                            {option.label}
                        </div>
                    );
                })}
            </div>
        </div>
    )
};

export default CustomDropdown;